import { render, staticRenderFns } from "./val.vue?vue&type=template&id=1bc00e9c&scoped=true&"
import script from "./val.vue?vue&type=script&lang=js&"
export * from "./val.vue?vue&type=script&lang=js&"
import style0 from "./val.vue?vue&type=style&index=0&id=1bc00e9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc00e9c",
  null
  
)

export default component.exports